export const FILTERS_MENU_HEADER_HEIGHT_PX = '56px'
